import { createRoute } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/payroll',
}).lazy(() => import('./payroll.lazy').then((d) => d.Route))
